export default "__VITE_ASSET__3a0d51d2__"